import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useState } from 'react';

import { setLightningRemind } from '@/api/mkt';
import Toast, { showToast, removeToast } from '@/components/common/Toast';
import { getLoginState } from '@/utils/common/user';

import styles from './lightningReminder.module.scss';
import NotifyAdd from './notify-add';

type ReminderProp = Partial<{
  id?: number;
  isReminded?: boolean;
  render;
}>;

function getSubStr(str: string) {
  if (str?.length >= 15) {
    let subStr1 = str.substr(0, 6);
    let subStr2 = str.substr(str.length - 5, 5);
    let subStr = subStr1 + '...' + subStr2;
    return subStr;
  }
  return str;
}

const Reminder = ({ id, isReminded }: ReminderProp) => {
  const { t, lang } = useTranslation('common');
  const [reminded, setReminded] = useState<boolean>(isReminded || false);
  const toggleCollect = (isCancel: boolean, newRemind?: boolean) => {
    const status = newRemind !== undefined ? newRemind : reminded;
    setLightningRemind({
      product_id: id,
      status: status ? 'X' : 'A'
    })
      .then(res => {
        if (res?.result) {
          setReminded(!status);

          if (isCancel) {
            return removeToast();
          }
          if (!status) {
            showToast(
              <NotifyAdd
                getLangMsg={() => t('has_add_notify_after_3_min')}
                getBtn={() => t('notify_cancel')}
                onCancel={() => toggleCollect(true, !reminded)}
              />,
              4000
            );
          }
        } else {
          Toast.info(res?.message);
        }
      })
      .catch(e => {
        Toast.info(e?.message);
      });
  };

  useEffect(() => {
    setReminded(isReminded);
  }, [isReminded]);

  const node = (
    <div
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        if (!getLoginState()) {
          window.location.href = `/${lang}/account/login?redirect_url=${encodeURIComponent(window.location.href)}`;
          return;
        }
        toggleCollect(false);
      }}
      className={classNames(styles.remindBtn, { [styles.reminded]: reminded })}
      data-role="remind-btn">
      {reminded ? getSubStr(t('lightning_reminded')) : t('lightning_remind')}
    </div>
  );
  return node;
};

const LightningReminder = props => {
  const { t, lang } = useTranslation('common');
  const { data } = props;

  return <Reminder id={data?.id} isReminded={data?.remind_set} />;
};

export default React.memo(LightningReminder);
